module.exports = __webpack_public_path__ + "img/bannerLabel1Orange.73d3b889.png";